import { DomSanitizer } from '@angular/platform-browser'
import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    const transformed = this.sanitized.bypassSecurityTrustHtml(value);
    if (transformed && transformed['changingThisBreaksApplicationSecurity'] && transformed['changingThisBreaksApplicationSecurity'] !== 'null') {
      return transformed;
    }
    return '';
  }
}